import { CSS, StyleProps } from "@shared/primitive-components"

export const root = (props: StyleProps): CSS => ({
  color: props.theme.palette.white,
})

export const title = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(1),
})

export const link = (props: StyleProps): CSS => ({
  color: props.theme.palette.white,
})
